import React, { useState, useEffect } from 'react';
import { Dropdown } from 'antd';
import moment from 'moment';

import DropdownContent from './DropdownContent';

import { getNotificacoesPorContrato } from '../../../services/notificacoes/notificacoes';
import { useGlobal } from '../../../contexts/Global/context';

import Icon from '../../Icons';

import { Container, Count } from './styles';

const urlRelationType = {
    1: 'faturamento/consultar_faturas',
    2: 'dados_contrato/carta_reajuste',
    3: 'faturamento/consultar_faturas',
};

export default function Notification() {
    const { contrastTheme, dataActiveContract } = useGlobal();
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        const contractNumber = dataActiveContract.numero;
        const contractType = dataActiveContract.regraEmpresa.porte;

        async function getNotifications() {
            const { data } = await getNotificacoesPorContrato(contractNumber, contractType);

            const formattedResponse =
                data?.map((notification) => {
                    const formattedDate = `${moment(notification.data).date()} ${moment(notification.data)
                        .format('MMMM')
                        .substring(0, 3)
                        .toLowerCase()}`;

                    const url = window.location.href + urlRelationType[notification.tipo];

                    return { ...notification, formattedDate, url };
                }) || [];

            setNotifications(formattedResponse);
        }

        getNotifications();
    }, []);

    return (
        <Dropdown
            overlay={() => <DropdownContent contrastTheme={contrastTheme} notifications={notifications} />}
            trigger={['click']}
            disabled={!notifications.length}
        >
            <Container>
                <Icon name="notifications" size={20} color={contrastTheme ? '#FFF333' : '#5B5B5F'} />
                <Count className="count">{notifications.length}</Count>
            </Container>
        </Dropdown>
    );
}
